import React, { FunctionComponent, memo } from "react";

import { TypedObject } from "@multiweb/types/react";
import { DraggableItemsContextProvider } from "./DraggableItemsContextProvider";
import { DraggableTreeItem, DraggableTreeItemProp } from "./DraggableTreeItem";
import { DraggableItem } from "./types";

export type DraggableTreeProps = {
    /** Seznam ID-ček kořenových prvků stromu. */
    readonly rootItems: readonly string[];
    /** Objekt obsahující definici všech prvků dragovatelného stromu. */
    readonly items: TypedObject<DraggableItem>;
} & Pick<DraggableTreeItemProp, "changeItemsHierarchy" | "itemRenderer" | "canDropItem" | "ignoreMiddlePosition">;

/** Komponenta pro zobrazení stromové struktury, umožňující dragování prvků napříc stromem. */
export const DraggableTree: FunctionComponent<DraggableTreeProps> = memo(({ rootItems, items, ignoreMiddlePosition = false, changeItemsHierarchy, itemRenderer, canDropItem }) => (
    <DraggableItemsContextProvider items={items}>
        {rootItems.map(x =>
            <DraggableTreeItem key={x} itemId={x} {...{ changeItemsHierarchy, itemRenderer, ignoreMiddlePosition, canDropItem }} />,
        )}
    </DraggableItemsContextProvider>
));
